// Utility functions

interface WineDisplayInput {
  wine_name?: string;
  producer?: string;
  varietal?: string;
  appellation?: string;
}

/**
 * Get display name for a wine
 * If wine_name exists, use it
 * Otherwise, combine producer + varietal or appellation
 */
export function getWineDisplayName(wine: WineDisplayInput): string {
  if (wine.wine_name) {
    return wine.wine_name;
  }
  
  // Build display name from producer + varietal or appellation
  const parts: string[] = [];
  
  if (wine.producer) {
    parts.push(wine.producer);
  }
  
  if (wine.varietal) {
    parts.push(wine.varietal);
  } else if (wine.appellation) {
    parts.push(wine.appellation);
  }
  
  return parts.join(' ') || 'Unknown Wine';
}

/**
 * Check if wine has a distinct name vs using producer+varietal
 */
export function hasDistinctName(wine: WineDisplayInput): boolean {
  return !!wine.wine_name;
}
